// Меню и стартовые страницы по ролям (роли из «User story IL Turismo»).
// Все роли работают в одном каркасе (layouts/variations/Backend.vue); что видит роль, определяет меню,
// а доступ к маршрутам ограничивает router.beforeEach. Данные фильтрует сам API (каждый видит своё).
import { MENU_ITEMS as ADMIN_MENU } from "@/data/Amenu.js";
import { canCreate, entityOfPath } from "@/data/entitySchemas";

export const ROLE_MENUS = {
  admin: ADMIN_MENU,

  client: [
    { id: 100, name: "Главная", link: "/home", icon: "si si-home" },
    { id: 101, name: "Туры", link: "/catalog", icon: "si si-map" },
    { id: 102, name: "Корзина", link: "/cart", icon: "si si-handbag" },
    { id: 103, name: "Мои заказы", link: "/orders", icon: "si si-basket" },
    { id: 104, name: "Оплаты", link: "/payments", icon: "si si-credit-card" },
    { id: 105, name: "Предложения для вас", link: "/personal-offers", icon: "si si-present" },
    { id: 106, name: "Профиль", link: "/client-profiles", icon: "si si-user" },
    { id: 107, name: "Поддержка", link: "/support-tickets", icon: "si si-support" },
    { id: 108, name: "Уведомления", link: "/notifications", icon: "si si-bell" },
  ],

  guide: [
    { id: 201, name: "Транспорт", link: "/vehicle-calendar", icon: "fa fa-car-side" },
    { id: 202, name: "Туры", link: "/tour-templates", icon: "si si-map" },
    { id: 203, name: "Заказы", link: "/orders", icon: "si si-basket" },
    { id: 204, name: "Участники туров", link: "/tour-participants", icon: "si si-users" },
    { id: 205, name: "Бронирования транспорта", link: "/vehicle-bookings", icon: "si si-clock" },
    { id: 206, name: "Финансы", link: "/payments", icon: "si si-credit-card" },
    { id: 207, name: "Профиль", link: "/guide-profiles", icon: "si si-user" },
    { id: 208, name: "Помощь", link: "/support-tickets", icon: "si si-support" },
    { id: 209, name: "Уведомления", link: "/notifications", icon: "si si-bell" },
  ],

  insurer: [
    { id: 301, name: "Запросы на страхование", link: "/insurance-requests", icon: "si si-docs" },
    { id: 302, name: "Профиль", link: "/insurer-profiles", icon: "si si-user" },
    { id: 303, name: "Помощь", link: "/support-tickets", icon: "si si-support" },
    { id: 304, name: "Уведомления", link: "/notifications", icon: "si si-bell" },
  ],

  transporter: [
    { id: 401, name: "Календарь загрузки", link: "/vehicle-calendar", icon: "si si-calendar" },
    { id: 402, name: "Мой транспорт", link: "/mycars", icon: "fa fa-car-side" },
    { id: 403, name: "Брони транспорта", link: "/vehicle-bookings", icon: "si si-clock" },
    { id: 404, name: "Финансы", link: "/cash", icon: "si si-wallet" },
    { id: 405, name: "Компания", link: "/transport-company/my", icon: "si si-briefcase" },
    { id: 406, name: "Помощь", link: "/support-tickets", icon: "si si-support" },
    { id: 407, name: "Уведомления", link: "/notifications", icon: "si si-bell" },
  ],
};

export const ROLE_HOME = {
  admin: "/Adashboard",
  client: "/home",
  guide: "/vehicle-calendar",
  insurer: "/insurance-requests",
  transporter: "/vehicle-calendar",
};

export const currentRole = () => localStorage.getItem("userrole");

export const menuForRole = (role = currentRole()) => ROLE_MENUS[role] || [];

/** Плоский список ссылок меню (с подпунктами). */
export const linksOf = (items) => items.flatMap((item) => [item.link, ...(item.sub ? linksOf(item.sub) : [])]).filter(Boolean);

/** Может ли роль открыть путь: админ — всё, остальные — разделы своего меню и вложенные страницы. */
export const canOpen = (role, path) => {
  if (role === "admin") return true;
  // Форму «Добавить» открывает только тот, кому эту сущность разрешено создавать (data/entitySchemas.js):
  // клиент — корзину, заказ, обращение, документ; но не туры, транспорт и услуги
  if (path.endsWith("/create") && !canCreate(entityOfPath(path), role)) return false;
  // Формы редактирования записей (например, заказа целиком) — только админу; остальные работают через карточки и действия
  if (path.endsWith("/edit")) return false;

  return linksOf(menuForRole(role)).some((link) => path === link || path.startsWith(link + "/"));
};

/** Все пункты меню всех ролей — для заголовков страниц. */
export const allMenuItems = () => Object.values(ROLE_MENUS).flat();
